var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_151859",
    "data-name": 151859,
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.717,
    height: 21.647,
    viewBox: "0 0 12.717 21.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18219",
    "data-name": "Group 18219",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9872",
    "data-name": "Path 9872",
    d: "M105.753,10.828l8.1-8.1a1.187,1.187,0,0,0,0-1.674l-.71-.709a1.186,1.186,0,0,0-1.675,0l-9.642,9.642a1.2,1.2,0,0,0,0,1.681l9.633,9.633a1.186,1.186,0,0,0,1.675,0l.709-.709a1.186,1.186,0,0,0,0-1.675Z",
    transform: "translate(-101.48 0)",
    fill: "#d4d4d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.de7fbbd8a1244a33b518e20ae7e05e6f.svg";
export { ForwardRef as ReactComponent };